/**
 * Captcha-related translations (FriendlyCaptcha, free-tier only).
 */

export const captcha = {
  freeTierNote: 'This verification is shown to free-tier users to reduce automated abuse.',
  required: 'Please complete the verification above.',
  gateTitle: 'Quick Verification',
  gateDescription: 'Please complete this verification before continuing.',
  gateCancel: 'Cancel',
  gateSubmit: 'Continue',
} as const;
